import { installationApi } from "../../api/installationApi"
import { accessToken } from "../../hooks/useAccessToken"
import { installationListSignal, installationListLoadingSignal, installationListErrorSignal } from "../signals/installationSignals"

export async function fetchInstallationList(businessEntityId, config, accessToken) {
    installationListLoadingSignal.value = true
    installationListErrorSignal.value = null

    try {
        const result = await installationApi.fetchInstallationList(businessEntityId, config, accessToken)
        installationListSignal.value = result.installation
    }
    catch (err) {
        installationListErrorSignal.value = err.message
    }
    finally {
        installationListLoadingSignal.value = false
    }
}